import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { LocationFillingType } from "../models/CatLocationFillingType";

export const getLocationFillingTypes = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[BYI].[GetCatLocationFillingTypes]", []);
};

export const upsertLocationFillingType = async (
  locationFillingType: LocationFillingType,
) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    {
      name: "LocationFillingType",
      value: locationFillingType.LocationFillingType,
    },
    { name: "Description", value: locationFillingType.Description },
  ];

  return await apiService.callV2(
    "[BYI].[UpsertCatLocationFillingType]",
    parameters,
  );
};

export const deleteLocationFillingType = async (
  locationFillingTypeId: number | null,
) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "LocationFillingTypeId", value: locationFillingTypeId },
  ];

  return await apiService.callV2(
    "[BYI].[DeleteCatLocationFillingType]",
    parameters,
  );
};
